/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCities } from "malaysia-postcodes";
const __vue_script__ = {
    props: ["customer_session_id"], 
    data() {
        return {
            countries_list: [],
            stateOptions: [],
            logo_file_path: "",
            phone_instance: null,
            formData: {
                customer_session_id: this.customer_session_id,
                pos_invoice_no: "",
                date: '',
                store_name: '',
                accept_privacy_policy_and_tac: false,

                //Personal details
                full_name: '',
                email_address: '',
                phone_number: '',
                customer_type: 'Individual',

                //Individual details
                identification_number_type: '',
                identification_number: '',
                individual_tin: '',

                //Company details
                company_name: '',
                company_id: '',
                company_tin: '',
                sst_number: '',

                //Address details
                address_line_1: '',
                address_line_2: '',
                country: '',
                state: '',
                city: '',
                postal_code: '',
            },
            form_error_data: {},
            isSubmitting: false, // Tracks if the form is being submitted
            isSubmitted: false,
            error: false,
            support_email_address: "",
        };
    },
    computed: {
        filteredStateOptions() {
            // Filter out "All State"
            return this.stateOptions.filter(option =>
                // option.state !== 'All States'
                option.name !== "00"
            )
        },
    },
    watch: {
        "formData.customer_type": function (newVal) {
            this.form_error_data = {};
            // Clear irrelevant fields based on the selected customer type
            if (newVal === "Individual") {
                this.formData.company_name = "";
                this.formData.company_id = "";
                this.formData.company_tin = "";
                this.formData.sst_number = "";
            } else if (newVal === "Company") {
                this.formData.individual_address = "";
                this.formData.identification_number_type = "";
                this.formData.identification_number = "";
                this.formData.individual_tin = "";
            }
        },
    },
    methods: {
        getPlaceholder(type) {
            switch (type) {
                case 'MyKad': return 'e.g. 971213081234';
                case 'Passport': return 'e.g. A12345678';
                case 'MyTentera': return 'e.g. 971213081234';
                default: return 'Please select identification number type!';
            }
        },
        cities() {
            //Convert state code (.name) to state name (.state)
            state_name = "";
            const selectedState = this.stateOptions.find(
                state_code => state_code.name === this.formData.state
            );
            if (selectedState) {
                state_name = selectedState.state;
            }
            // Return cities dictionary for primevue Select component
            if (state_name === 'Wilayah Persekutuan Kuala Lumpur') //The library only recognise "Wp Kuala Lumpur", "Wp Labuan" and "Wp Putrajaya"
                return [{'name': 'Kuala Lumpur'}]
            else if (state_name === 'Wilayah Persekutuan Labuan')
                return [{'name': "Labuan"}]
            else if (state_name === 'Wilayah Persekutuan Putrajaya')
                return [{'name': "Putrajaya"}]
            else if (state_name === 'Pulau Pinang')
                state_name = "Penang"
            return getCities(state_name).map(city => {return {'name': city};});
        },
        get_pos_invoice_no() {
            frappe.call({
                method: "myinvois.api.get_pos_invoice_no",
                args: {
                    customer_session_id: this.customer_session_id,
                },
                callback: (response) => {
                    if (response.success) {
                        this.formData.pos_invoice_no = response.message.pos_invoice_no;
                        this.formData.store_name = response.message.store_name;
                        this.formData.date = response.message.transaction_date;
                        this.logo_file_path = response.message.logo_file_path;
                    } else {
                        this.error = true;
                        this.support_email_address = response.message.support_email_address;
                    }
                }
            });
        },
        validate_form() {
            let isValid = true;
            this.form_error_data = {}; // Clear previous errors
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            const passportPattern = /^[AHKahk]\d{8}$/;
            const individualTINPattern = /^(IG)(\d{9,11})$/;
            const nonIndividualTINPattern = /^[CDEF](\d{9,11})0$/;
            const nricPattern = /^\d{6}\d{2}\d{4}$/;
            const brnPattern = /^\d{4}(01|02|03|04|05|06)\d{6}$/;
            const sstRegNoPattern = /^[A-Z]\d{2}\d{4}\d{8}$/;
            const email_input = document.querySelector("#email-field");
            const phone_input = document.querySelector("#phone");
            const identification_number_input = document.querySelector("#identification_number");
            const individual_tin_input = document.querySelector("#individual_tin");
            const company_tin_input = document.querySelector("#company_tin");
            const company_id_input = document.querySelector("#company_id");
            const company_sst_number_input = document.querySelector("#company_sst_number");

            const patterns = {
                'MyKad': nricPattern,
                'MyTentera': nricPattern,
                'Passport': passportPattern,
            };

            if (this.formData.customer_type === "Individual") {
                // Identification Number Type
                if (this.formData.identification_number_type) {
                    // Identification Number
                    if (identification_number_input) {
                        const value = this.formData.identification_number;
                        const pattern = patterns[this.formData.identification_number_type];
                        const errorMessage = `Please enter a valid ${this.formData.identification_number_type} number.`;
                        if (!value || value === null || !pattern.test(value)) {
                            this.form_error_data.identification_number = errorMessage;
                            isValid = false;
                            identification_number_input.style.borderColor = "red";
                        } else {
                            identification_number_input.style.borderColor = "";
                        }
                    } else {
                        console.error(`${this.formData.identification_number_type.toUpperCase()} input element not found.`);
                    }
                } else {
                    console.error("Identification number type is not specified.");
                }

                // Individual TIN
                if (!this.formData.individual_tin || this.formData.individual_tin === null || !individualTINPattern.test(this.formData.individual_tin)) {
                    this.form_error_data.individual_tin = "Please enter a valid TIN.";
                    isValid = false;
                    individual_tin_input.style.borderColor = "red";
                } else {
                    individual_tin_input.style.borderColor = "";
                }
            }

            // Company 
            if (this.formData.customer_type === "Company") {
                // Company TIN
                if (!this.formData.company_tin || this.formData.company_tin === null || !nonIndividualTINPattern.test(this.formData.company_tin)) {
                    this.form_error_data.company_tin = "Please enter a valid TIN.";
                    isValid = false;
                    company_tin_input.style.borderColor = "red";
                } else {
                    company_tin_input.style.borderColor = "";
                }
                // Company BRN / Company ID
                if (!this.formData.company_id || this.formData.company_id === null || !brnPattern.test(this.formData.company_id)) {
                    this.form_error_data.company_id = "Please enter a valid BRN.";
                    isValid = false;
                    company_id_input.style.borderColor = "red";
                } else {
                    company_id_input.style.borderColor = "";
                }
                // Company SST Registration No
                if (this.formData.sst_number !== "" && !sstRegNoPattern.test(this.formData.sst_number)) {
                    this.form_error_data.company_sst_number = "Please enter a valid SST Registration No.";
                    isValid = false;
                    company_sst_number_input.style.borderColor = "red";
                } else {
                    company_sst_number_input.style.borderColor = "";
                }
            }

            // Email Address
            if (!this.formData.email_address || !emailPattern.test(this.formData.email_address)) {
                this.form_error_data.email = "Please enter a valid email address.";
                isValid = false;
                email_input.style.borderColor = "red";
            } else {
                email_input.style.borderColor = "";
            }
            // Phone Number
            if (!this.phone_instance) {
                if (!phone_input.value) {
                    this.form_error_data.phone = "Please enter a phone number.";
                    isValid = false;
                    phone_input.style.borderColor = "red";
                } else {
                    phone_input.style.borderColor = "";
                }
            } else {
                const isValidPhone = this.phone_instance.isValidNumber();
                if (!isValidPhone) {
                    this.form_error_data.phone = "Please enter a valid phone number.";
                    isValid = false;
                    phone_input.style.borderColor = "red";
                } else {
                    phone_input.style.borderColor = "";
                }
            }
            return isValid;
        },
        submitForm() { //Fill in the E-Invoice Request record.
            if (this.isSubmitting || this.isSubmitted) return;
            const isValid = this.validate_form();
            if (!isValid) return;
            this.update_phone_number();
            this.isSubmitting = true;
            frappe.call({
                method: "myinvois.api.create_einvoice_request_record",
                args: { formData: this.formData },
                callback: (response) => {
                    if (response.success) {
                        this.isSubmitted = true;
                        frappe.show_alert({
                            title: "Success",
                            indicator: "green",
                            message: "Data submitted successfully.",
                        });
                    }
                    else {
                        frappe.msgprint({
                            title: "Invalid",
                            indicator: "red",
                            message: response.message,
                        });
                    }
                },
                error: () => {
                    this.isSubmitting = false;
                }
            });
        },
        fetchValues() { // Map back the E-Invoice Request Record if it is submitted.
            frappe.call({
                method: "myinvois.api.fetch_einvoice_request_record",
                args: {
                    customer_session_id: this.customer_session_id
                },
                callback: (response) => {
                    if (response.success) {
                        einvoice_request_doc = response['einvoice_request_doc'];
                        if (einvoice_request_doc.docstatus == 1) {
                            this.isSubmitted = true; //disabled the form inputs
                            //Personal details
                            this.formData.full_name = einvoice_request_doc.full_name;
                            this.formData.email_address = einvoice_request_doc.email_address;
                            this.formData.customer_type = einvoice_request_doc.customer_type;
                            this.formData.address_line_1 = einvoice_request_doc.address_line_1;
                            this.formData.address_line_2 = einvoice_request_doc.address_line_2;
                            this.formData.state = einvoice_request_doc.state;
                            this.formData.city = einvoice_request_doc.city;
                            this.formData.country = einvoice_request_doc.country;
                            this.formData.postal_code = einvoice_request_doc.postal_code;
                            this.formData.accept_privacy_policy_and_tac = Boolean(einvoice_request_doc.accept_privacy_policy_and_tac);
                            // Update intl-tel-input instance with the fetched phone number
                            if (this.phone_instance) {
                                this.phone_instance.setNumber(einvoice_request_doc.mobile_number);
                            }
                            //Individual details
                            if (einvoice_request_doc.customer_type == "Individual") {
                                this.formData.identification_number_type = einvoice_request_doc.identification_number_type;
                                this.formData.identification_number = einvoice_request_doc.identification_number;
                                this.formData.individual_tin = einvoice_request_doc.individual_tin;
                            }
                            //Company details
                            else if (einvoice_request_doc.customer_type == "Company") {
                                this.formData.company_name = einvoice_request_doc.company_name;
                                this.formData.company_id = einvoice_request_doc.company_id;
                                this.formData.company_tin = einvoice_request_doc.company_tin;
                                this.formData.sst_number = einvoice_request_doc.sst_registration_no;
                            }

                        }
                    }
                },

            })
        },
        initPhoneInput() {
            const phone_input = document.querySelector("#phone");
            if (!phone_input) {
                console.error("Phone input element not found!");
                return;
            }
            this.phone_instance = intlTelInput(phone_input, {
                initialCountry: "my",
                loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js"),
                separateDialCode: true,
                useFullscreenPopup: false,
                autoPlaceholder: "aggressive"
            });
            phone_input.addEventListener("input", this.update_phone_number);
            phone_input.addEventListener("countrychange", this.update_phone_number);
        },
        update_phone_number() {
            if (this.phone_instance) {
                const formatted_number = this.phone_instance.getNumber();
                const is_valid = this.phone_instance.isValidNumber();
                if (is_valid !== false) {
                    this.formData.phone_number = formatted_number;
                }
            }
        },
        ignore_dash_character(event) {
            const inputElement = event.target;
            inputElement.value = inputElement.value.replace(/-/g, ''); // Remove "-" from input while typing in.
        },
        get_country_and_state_codes() {
            frappe.call({
                method: "myinvois.api.get_country_and_state_codes",
                args: {},
                callback: (response) => {
                    if (response.message) {
                        this.stateOptions = response.message.state_codes;
                        this.countries_list = response.message.countries;
                    }
                }
            });
        },
    },
    mounted() {
        this.get_pos_invoice_no();
        this.get_country_and_state_codes();
        this.fetchValues();
        this.$nextTick(() => {
            this.initPhoneInput();
        });
    },
    beforeUnmount() {
        // Clean up the intl-tel-input instance
        if (this.phone_instance) {
            this.phone_instance.destroy();
        }
    },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.error
    ? _c(
        "div",
        {
          staticStyle: {
            width: "90%",
            display: "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "center",
            "margin-top": "10rem"
          }
        },
        [
          _c("img", {
            staticStyle: { width: "40rem", margin: "1rem" },
            attrs: {
              src: "/assets/myinvois/images/Error Page Image.png",
              alt: "Logo"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "error-box" }, [
            _c("p", { staticStyle: { "margin-bottom": "0" } }, [
              _vm._v("Invalid session link."),
              _c("br"),
              _vm._v("If you have any concern, please contact us at "),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _c(
                  "a",
                  { attrs: { href: "mailto:" + _vm.support_email_address } },
                  [_vm._v(_vm._s(_vm.support_email_address))]
                )
              ])
            ])
          ])
        ]
      )
    : _c("div", { staticStyle: { width: "100%" } }, [
        _c("div", { staticClass: "header-container" }, [
          _c("img", {
            staticStyle: { width: "9rem", margin: "1rem" },
            attrs: { src: _vm.logo_file_path, alt: "Logo" }
          }),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-container" }, [
          _vm.isSubmitted
            ? _c(
                "div",
                {
                  staticClass: "rounded",
                  staticStyle: { "background-color": "#e4e4e4" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        "margin-top": "20px"
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "40px",
                            height: "40px",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: "0.5",
                              d:
                                "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
                              fill: "#008000"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z",
                              fill: "#ffffff"
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "font-size": "14px",
                        "font-weight": "bold",
                        "justify-content": "center",
                        margin: "8px"
                      }
                    },
                    [
                      _vm._v(
                        "\n                Congratulations! Your E-Invoice request has been successfully submitted.\n            "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submitForm.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.pos_invoice_no,
                      expression: "formData.pos_invoice_no"
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "POS Invoice No",
                    disabled: ""
                  },
                  domProps: { value: _vm.formData.pos_invoice_no },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.formData,
                        "pos_invoice_no",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.date,
                      expression: "formData.date"
                    }
                  ],
                  attrs: { type: "text", placeholder: "Date", disabled: "" },
                  domProps: { value: _vm.formData.date },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "date", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.store_name,
                      expression: "formData.store_name"
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "Store Name",
                    disabled: ""
                  },
                  domProps: { value: _vm.formData.store_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "store_name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("hr", { attrs: { width: "100%", size: "4", noshade: "" } }),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.full_name,
                      expression: "formData.full_name"
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "e.g. Syatifah binti Ibrahim",
                    required: "",
                    disabled: _vm.isSubmitted
                  },
                  domProps: { value: _vm.formData.full_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "full_name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.email_address,
                      expression: "formData.email_address"
                    }
                  ],
                  attrs: {
                    id: "email-field",
                    type: "text",
                    placeholder: "e.g. syatifah@gmail.com",
                    required: "",
                    disabled: _vm.isSubmitted
                  },
                  domProps: { value: _vm.formData.email_address },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.formData,
                        "email_address",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-error-msg",
                    staticStyle: { "font-size": "0.875rem" }
                  },
                  [
                    _vm.form_error_data.email
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.form_error_data.email))
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    id: "phone",
                    type: "tel",
                    disabled: _vm.isSubmitted,
                    required: ""
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-error-msg",
                    staticStyle: { "font-size": "0.875rem" }
                  },
                  [
                    _vm.form_error_data.phone
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.form_error_data.phone))
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "customer_type" } }, [
                _vm._v("Claim as:")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    gap: "25px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "form-check",
                      staticStyle: { display: "flex" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData.customer_type,
                            expression: "formData.customer_type"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "customer_type",
                          value: "Individual",
                          id: "individual",
                          required: "",
                          disabled: _vm.isSubmitted
                        },
                        domProps: {
                          checked: _vm.formData.customer_type === "Individual",
                          checked: _vm._q(
                            _vm.formData.customer_type,
                            "Individual"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.formData,
                              "customer_type",
                              "Individual"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          staticStyle: { cursor: "pointer" },
                          attrs: { for: "individual" }
                        },
                        [
                          _vm._v(
                            "\n                        Individual\n                    "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-check",
                      staticStyle: { display: "flex" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData.customer_type,
                            expression: "formData.customer_type"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "customer_type",
                          value: "Company",
                          id: "company",
                          required: "",
                          disabled: _vm.isSubmitted
                        },
                        domProps: {
                          checked: _vm.formData.customer_type === "Company",
                          checked: _vm._q(_vm.formData.customer_type, "Company")
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.formData,
                              "customer_type",
                              "Company"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          staticStyle: { cursor: "pointer" },
                          attrs: { for: "company" }
                        },
                        [
                          _vm._v(
                            "\n                        Company\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("p"),
              _vm._v(" "),
              _vm.formData.customer_type
                ? _c("hr", { attrs: { width: "100%", size: "4", noshade: "" } })
                : _vm._e(),
              _vm._v(" "),
              _vm.formData.customer_type === "Individual"
                ? _c("div", [
                    _c(
                      "h5",
                      {
                        staticStyle: {
                          "font-size": "medium",
                          "font-weight": "bold",
                          "margin-bottom": "20px"
                        }
                      },
                      [_vm._v("INDIVIDUAL DETAILS")]
                    ),
                    _vm._v(" "),
                    _c("p"),
                    _vm._v(" "),
                    _vm._m(8),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "15px",
                          "margin-bottom": "10px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-check",
                            staticStyle: { display: "flex" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.formData.identification_number_type,
                                  expression:
                                    "formData.identification_number_type"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "identification_number_type",
                                value: "MyKad",
                                id: "NRIC",
                                required: "",
                                disabled: _vm.isSubmitted
                              },
                              domProps: {
                                checked:
                                  _vm.formData.identification_number_type ===
                                  "MyKad",
                                checked: _vm._q(
                                  _vm.formData.identification_number_type,
                                  "MyKad"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.formData,
                                    "identification_number_type",
                                    "MyKad"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                staticStyle: { cursor: "pointer" },
                                attrs: { for: "NRIC" }
                              },
                              [
                                _vm._v(
                                  "\n                            MyKad\n                        "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-check",
                            staticStyle: { display: "flex" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.formData.identification_number_type,
                                  expression:
                                    "formData.identification_number_type"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "identification_number_type",
                                id: "Passport",
                                value: "Passport",
                                required: "",
                                disabled: _vm.isSubmitted
                              },
                              domProps: {
                                checked:
                                  _vm.formData.identification_number_type ===
                                  "Passport",
                                checked: _vm._q(
                                  _vm.formData.identification_number_type,
                                  "Passport"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.formData,
                                    "identification_number_type",
                                    "Passport"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                staticStyle: { cursor: "pointer" },
                                attrs: { for: "Passport" }
                              },
                              [
                                _vm._v(
                                  "\n                            Passport\n                        "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-check",
                            staticStyle: { display: "flex" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.formData.identification_number_type,
                                  expression:
                                    "formData.identification_number_type"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "identification_number_type",
                                id: "Army",
                                value: "MyTentera",
                                required: "",
                                disabled: _vm.isSubmitted
                              },
                              domProps: {
                                checked:
                                  _vm.formData.identification_number_type ===
                                  "MyTentera",
                                checked: _vm._q(
                                  _vm.formData.identification_number_type,
                                  "MyTentera"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.formData,
                                    "identification_number_type",
                                    "MyTentera"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                staticStyle: { cursor: "pointer" },
                                attrs: { for: "Army" }
                              },
                              [
                                _vm._v(
                                  "\n                            MyTentera\n                        "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData.identification_number,
                            expression: "formData.identification_number"
                          }
                        ],
                        attrs: {
                          type: "text",
                          placeholder: _vm.getPlaceholder(
                            _vm.formData.identification_number_type
                          ),
                          required: _vm.formData.identification_number_type,
                          disabled:
                            _vm.isSubmitted ||
                            _vm.formData.identification_number_type === "",
                          id: "identification_number"
                        },
                        domProps: { value: _vm.formData.identification_number },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.formData,
                                "identification_number",
                                $event.target.value
                              )
                            },
                            _vm.ignore_dash_character
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-error-msg",
                          staticStyle: { "font-size": "0.875rem" }
                        },
                        [
                          _vm.form_error_data.identification_number
                            ? _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.form_error_data.identification_number
                                    ) +
                                    "\n                        "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        staticStyle: { "margin-bottom": "10px" }
                      },
                      [
                        _vm._m(9),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formData.individual_tin,
                              expression: "formData.individual_tin"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "e.g. C1212341234",
                            disabled: _vm.isSubmitted,
                            id: "individual_tin",
                            required: ""
                          },
                          domProps: { value: _vm.formData.individual_tin },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  "individual_tin",
                                  $event.target.value
                                )
                              },
                              _vm.ignore_dash_character
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-error-msg",
                            staticStyle: { "font-size": "0.875rem" }
                          },
                          [
                            _vm.form_error_data.individual_tin
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(_vm.form_error_data.individual_tin)
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ])
                : _vm.formData.customer_type === "Company"
                ? _c("div", [
                    _c(
                      "h5",
                      {
                        staticStyle: {
                          "font-size": "medium",
                          "font-weight": "bold",
                          "margin-bottom": "20px"
                        }
                      },
                      [_vm._v("COMPANY DETAILS")]
                    ),
                    _vm._v(" "),
                    _c("p"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        staticStyle: { "margin-bottom": "10px" }
                      },
                      [
                        _vm._m(10),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formData.company_name,
                              expression: "formData.company_name"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "e.g. Coffee Shop Sdn. Bhd.",
                            required: "",
                            disabled: _vm.isSubmitted
                          },
                          domProps: { value: _vm.formData.company_name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.formData,
                                "company_name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        staticStyle: { "margin-bottom": "10px" }
                      },
                      [
                        _vm._m(11),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formData.company_id,
                              expression: "formData.company_id"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "e.g. 201909123456",
                            required: "",
                            disabled: _vm.isSubmitted,
                            id: "company_id"
                          },
                          domProps: { value: _vm.formData.company_id },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  "company_id",
                                  $event.target.value
                                )
                              },
                              _vm.ignore_dash_character
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-error-msg",
                            staticStyle: { "font-size": "0.875rem" }
                          },
                          [
                            _vm.form_error_data.company_id
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(_vm._s(_vm.form_error_data.company_id))
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        staticStyle: { "margin-bottom": "10px" }
                      },
                      [
                        _vm._m(12),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formData.company_tin,
                              expression: "formData.company_tin"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "e.g. C1212341234",
                            disabled: _vm.isSubmitted,
                            id: "company_tin",
                            required: ""
                          },
                          domProps: { value: _vm.formData.company_tin },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  "company_tin",
                                  $event.target.value
                                )
                              },
                              _vm.ignore_dash_character
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-error-msg",
                            staticStyle: { "font-size": "0.875rem" }
                          },
                          [
                            _vm.form_error_data.company_tin
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(_vm.form_error_data.company_tin)
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        staticStyle: { "margin-bottom": "10px" }
                      },
                      [
                        _c("label", { attrs: { for: "sst_registration_no" } }, [
                          _vm._v(
                            "SST Registration Number (Mandatory for SST-registrant)"
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formData.sst_number,
                              expression: "formData.sst_number"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "e.g. X89-2104-12345678",
                            disabled: _vm.isSubmitted,
                            id: "company_sst_number"
                          },
                          domProps: { value: _vm.formData.sst_number },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  "sst_number",
                                  $event.target.value
                                )
                              },
                              _vm.ignore_dash_character
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-error-msg",
                            staticStyle: { "font-size": "0.875rem" }
                          },
                          [
                            _vm.form_error_data.company_sst_number
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.form_error_data.company_sst_number
                                    )
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(13),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.address_line_1,
                      expression: "formData.address_line_1"
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "e.g. Unit No, Street Name",
                    disabled: _vm.isSubmitted,
                    required: ""
                  },
                  domProps: { value: _vm.formData.address_line_1 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.formData,
                        "address_line_1",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "address" } }, [
                  _vm._v("Address Line 2 ")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.address_line_2,
                      expression: "formData.address_line_2"
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "e.g. Unit No, Street Name",
                    disabled: _vm.isSubmitted
                  },
                  domProps: { value: _vm.formData.address_line_2 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.formData,
                        "address_line_2",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(14),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.country,
                        expression: "formData.country"
                      }
                    ],
                    staticClass: "w-full md:w-56",
                    attrs: {
                      disabled: _vm.isSubmitted,
                      placeholder: "Select a Country"
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.formData,
                          "country",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.countries_list, function(country) {
                    return _c("option", { domProps: { value: country.name } }, [
                      _vm._v(_vm._s(country.name))
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(15),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.state,
                        expression: "formData.state"
                      }
                    ],
                    staticClass: "w-full md:w-56",
                    attrs: {
                      disabled: _vm.isSubmitted,
                      placeholder: "Select a State"
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.formData,
                          "state",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.filteredStateOptions, function(state) {
                    return _c("option", { domProps: { value: state.name } }, [
                      _vm._v(_vm._s(state.state))
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(16),
                _vm._v(" "),
                _vm.formData.state !== "17" &&
                _vm.formData.country === "Malaysia"
                  ? _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData.city,
                            expression: "formData.city"
                          }
                        ],
                        class: {
                          select_background_white: !_vm.isSubmitted,
                          select_background_grey: _vm.isSubmitted
                        },
                        attrs: { required: "", disabled: _vm.isSubmitted },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.formData,
                              "city",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.cities(), function(city, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: city } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(city) +
                                "\n                    "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm.formData.state === "17" &&
                    _vm.formData.country === "Malaysia"
                  ? _c("input", {
                      attrs: {
                        type: "text",
                        placeholder: "Please select a state in Malaysia!",
                        disabled: ""
                      }
                    })
                  : _vm.formData.state === "17" &&
                    _vm.formData.country !== "Malaysia"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.city,
                          expression: "formData.city"
                        }
                      ],
                      attrs: {
                        type: "text",
                        required: "",
                        disabled: _vm.isSubmitted,
                        placeholder: "e.g. New York"
                      },
                      domProps: { value: _vm.formData.city },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.formData, "city", $event.target.value)
                        }
                      }
                    })
                  : _vm.formData.state
                  ? _c("input", {
                      attrs: {
                        type: "text",
                        placeholder: "Select 'Not Applicable' on 'State'.",
                        disabled: ""
                      }
                    })
                  : _c("input", {
                      attrs: {
                        type: "text",
                        placeholder: "Please choose 'State' first.",
                        disabled: ""
                      }
                    })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(17),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.postal_code,
                      expression: "formData.postal_code"
                    }
                  ],
                  attrs: {
                    type: "text",
                    id: "postal_code",
                    placeholder: "e.g. 43200",
                    required: "",
                    disabled: _vm.isSubmitted
                  },
                  domProps: { value: _vm.formData.postal_code },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "postal_code", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group d-flex mt-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.accept_privacy_policy_and_tac,
                      expression: "formData.accept_privacy_policy_and_tac"
                    }
                  ],
                  attrs: {
                    type: "checkbox",
                    id: "agreement",
                    required: "",
                    disabled: _vm.isSubmitted
                  },
                  domProps: {
                    checked: Array.isArray(
                      _vm.formData.accept_privacy_policy_and_tac
                    )
                      ? _vm._i(
                          _vm.formData.accept_privacy_policy_and_tac,
                          null
                        ) > -1
                      : _vm.formData.accept_privacy_policy_and_tac
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.formData.accept_privacy_policy_and_tac,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.formData,
                              "accept_privacy_policy_and_tac",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.formData,
                              "accept_privacy_policy_and_tac",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(
                          _vm.formData,
                          "accept_privacy_policy_and_tac",
                          $$c
                        )
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "agreement-label",
                    attrs: { for: "agreement" }
                  },
                  [
                    _vm._v(
                      "By ticking this box, you consent to abide by the\n                    "
                    ),
                    _c(
                      "a",
                      {
                        staticStyle: {
                          color: "#6b68ff",
                          "text-decoration": "underline"
                        },
                        attrs: {
                          href: "/terms-and-conditions",
                          target: "_blank"
                        }
                      },
                      [_vm._v("Terms and Conditions")]
                    ),
                    _vm._v(" as well as "),
                    _c(
                      "a",
                      {
                        staticStyle: {
                          color: "#6b68ff",
                          "text-decoration": "underline"
                        },
                        attrs: { href: "/privacy-policy", target: "_blank" }
                      },
                      [_vm._v("Privacy Policy")]
                    ),
                    _vm._v(
                      "\n                    outlined herein. Please review the terms\n                    carefully before proceeding. Your acceptance indicates your understanding and agreement to be\n                    bound by these terms."
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-error-msg",
                    staticStyle: { "font-size": "0.875rem" }
                  },
                  [
                    _vm.form_error_data.agreement
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.form_error_data.agreement))
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-primary",
                    class: { "btn-success": _vm.isSubmitted },
                    staticStyle: {
                      "border-radius": "2rem",
                      "font-weight": "bold"
                    },
                    attrs: {
                      type: "submit",
                      disabled: _vm.isSubmitting || _vm.isSubmitted
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.isSubmitted
                            ? "Submitted"
                            : _vm.isSubmitting
                            ? "Submitting..."
                            : "Submit"
                        ) +
                        "\n                "
                    )
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                "margin-top": "2rem",
                color: "#398bff",
                "font-size": "14px"
              }
            },
            [
              _vm._v("\n            Powered by "),
              _c(
                "a",
                {
                  staticStyle: { color: "#398bff" },
                  attrs: {
                    href: "https://www.byondwave.com/",
                    target: "_blank"
                  }
                },
                [_vm._v("BYONDWAVE.com")]
              )
            ]
          )
        ])
      ])
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _vm._v("E-Invoice "),
      _c("br", { staticClass: "mobile-next" }),
      _vm._v(" Submission Form ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "pos_invoice_no" } }, [
      _vm._v("POS Invoice No "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "unstyled", attrs: { for: "date" } }, [
      _vm._v("Transaction Date (YYYY-MM-DD)"),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "store_name" } }, [
      _vm._v("Store Name "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "h5",
        {
          staticStyle: {
            "font-size": "medium",
            "font-weight": "bold",
            "margin-bottom": "20px"
          }
        },
        [_vm._v("PERSONAL DETAILS")]
      ),
      _vm._v(" "),
      _c("p")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "full_name" } }, [
      _vm._v("Full Name (as per ID) "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "email_address" } }, [
      _vm._v("Email Address "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "phone_number" } }, [
      _vm._v("Phone Number "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "individual-type" } }, [
      _vm._v("Individual ID "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "tax_id" } }, [
      _vm._v("Individual Tax Identification Number (TIN) "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "company-name" } }, [
      _vm._v("Company Name "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "company-id" } }, [
      _vm._v("Company ID - Business Registration Number (BRN) "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "tax_id" } }, [
      _vm._v("Company Tax Identification Number (TIN) "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "address" } }, [
      _vm._v("Address Line 1 "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "country" } }, [
      _vm._v("Country "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "state" } }, [
      _vm._v("State "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "city" } }, [
      _vm._v("City "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "city" } }, [
      _vm._v("Postal Code "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-dd8c2920_0", { source: "\n.header-container[data-v-dd8c2920] {\r\n    text-align: center;\r\n    background-color: #3663e6;\r\n    padding: 20px;\r\n    max-width: 600px;\r\n    margin: 3rem auto 0 auto;\r\n    border-top-left-radius: 1rem;\r\n    border-top-right-radius: 1rem;\n}\nh4[data-v-dd8c2920] {\r\n    color: white;\r\n    margin-top: 1.2rem;\r\n    margin-bottom: 0.5rem;\r\n    font-weight: bold;\n}\n.form-container[data-v-dd8c2920] {\r\n    background: white;\r\n    padding: 20px 50px;\r\n    max-width: 600px;\r\n    margin: 0rem auto 3rem auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    border-bottom-left-radius: 1rem;\r\n    border-bottom-right-radius: 1rem;\n}\n.form-group[data-v-dd8c2920] {\r\n    margin-bottom: 20px;\n}\nlabel[data-v-dd8c2920] {\r\n    font-weight: 600;\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    color: #555;\n}\ninput[data-v-dd8c2920] {\r\n    border-radius: 10px !important;\n}\ninput[data-v-dd8c2920]:not([type=\"radio\"]),\r\nselect[data-v-dd8c2920] {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 10px;\r\n    font-size: 14px;\r\n    transition: border-color 0.2s ease;\n}\ninput[data-v-dd8c2920]:focus,\r\nselect[data-v-dd8c2920]:focus {\r\n    border-color: #007bff;\r\n    outline: none;\n}\n.form-actions[data-v-dd8c2920] {\r\n    text-align: center;\n}\n.btn-primary[data-v-dd8c2920] {\r\n    background-color: #007bff;\r\n    border: none;\r\n    color: white;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease;\n}\n.btn-primary[data-v-dd8c2920]:hover {\r\n    background-color: #0056b3;\n}\n.example-text[data-v-dd8c2920] {\r\n    color: #93999c;\r\n    margin-bottom: 5px;\r\n    font-size: 14px;\n}\n.mobile-next[data-v-dd8c2920] {\r\n    display: none;\n}\n.error-box[data-v-dd8c2920] {\r\n    background-color: #f8d7da;\r\n    color: #721c24;\r\n    border: 1px solid #f5c6cb;\r\n    border-radius: 5px;\r\n    margin: 0 2rem;\r\n    padding: 20px;\r\n    font-size: 16px;\r\n    text-align: center;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\n}\n.btn-success[data-v-dd8c2920] {\r\n    background-color: #28a745;\r\n    color: white;\r\n    border-color: #28a745;\n}\n.select_background_white[data-v-dd8c2920] {\r\n    background-color: white;\r\n    color: black;\n}\n.select_background_grey[data-v-dd8c2920] {\r\n    background-color: #f8f8f8;\r\n    color: black;\n}\n.unstyled[data-v-dd8c2920] {\r\n    appearance: none;\r\n    -webkit-appearance: none;\n}\n.unstyled[data-v-dd8c2920]::-webkit-inner-spin-button,\r\n.unstyled[data-v-dd8c2920]::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\n}\nlabel[data-v-dd8c2920] {\r\n    font-size: 1rem;\n}\n#agreement[data-v-dd8c2920] {\r\n    border-radius: 6px !important;\r\n    margin: 5px 11px 0 0 !important;\r\n    padding: 8px;\n}\n.agreement-label[data-v-dd8c2920] {\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    text-align: justify;\n}\n@media (max-width: 575.99px) {\n.header-container[data-v-dd8c2920] {\r\n        margin: 1rem 2rem 0 2rem;\n}\n.form-container[data-v-dd8c2920] {\r\n        margin: 0rem 2rem 1rem 2rem;\r\n        padding: 20px;\n}\n.mobile-next[data-v-dd8c2920] {\r\n        display: block;\n}\nh4[data-v-dd8c2920] {\r\n        font-size: 1.5rem;\n}\nlabel[data-v-dd8c2920] {\r\n        font-size: 0.875rem;\n}\n.agreement-label[data-v-dd8c2920] {\r\n        font-size: 12px;\n}\n}\r\n", map: {"version":3,"sources":["../myinvois/myinvois/public/js/einvoice_request/Home.vue"],"names":[],"mappings":";AAqnBA;IACA,kBAAA;IACA,yBAAA;IACA,aAAA;IACA,gBAAA;IACA,wBAAA;IACA,4BAAA;IACA,6BAAA;AACA;AAEA;IACA,YAAA;IACA,kBAAA;IACA,qBAAA;IACA,iBAAA;AACA;AAEA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,2BAAA;IACA,aAAA;IACA,sBAAA;IACA,yCAAA;IACA,+BAAA;IACA,gCAAA;AACA;AAEA;IACA,mBAAA;AACA;AAEA;IACA,gBAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;AACA;AAEA;IACA,8BAAA;AACA;AAEA;;IAEA,WAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;IACA,kCAAA;AACA;AAEA;;IAEA,qBAAA;IACA,aAAA;AACA;AAEA;IACA,kBAAA;AACA;AAEA;IACA,yBAAA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,kBAAA;IACA,eAAA;IACA,sCAAA;AACA;AAEA;IACA,yBAAA;AACA;AAEA;IACA,cAAA;IACA,kBAAA;IACA,eAAA;AACA;AAEA;IACA,aAAA;AACA;AAEA;IACA,yBAAA;IACA,cAAA;IACA,yBAAA;IACA,kBAAA;IACA,cAAA;IACA,aAAA;IACA,eAAA;IACA,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;AACA;AAEA;IACA,yBAAA;IACA,YAAA;IACA,qBAAA;AACA;AAEA;IACA,uBAAA;IACA,YAAA;AACA;AAEA;IACA,yBAAA;IACA,YAAA;AACA;AAEA;IACA,gBAAA;IACA,wBAAA;AACA;AAEA;;IAEA,aAAA;IACA,wBAAA;AACA;AAEA;IACA,eAAA;AACA;AAEA;IACA,6BAAA;IACA,+BAAA;IACA,YAAA;AACA;AAEA;IACA,eAAA;IACA,eAAA;IACA,mBAAA;AACA;AAEA;AACA;QACA,wBAAA;AACA;AAEA;QACA,2BAAA;QACA,aAAA;AACA;AAEA;QACA,cAAA;AACA;AAEA;QACA,iBAAA;AACA;AAEA;QACA,mBAAA;AACA;AAEA;QACA,eAAA;AACA;AACA","file":"Home.vue","sourcesContent":["<template>\r\n    <div v-if=\"error\"\r\n        style=\"width: 90%; display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top:10rem;\">\r\n        <img src=\"/assets/myinvois/images/Error Page Image.png\" alt=\"Logo\" style=\"width: 40rem; margin: 1rem;\" />\r\n        <div class=\"error-box\">\r\n            <p style=\"margin-bottom: 0;\">Invalid session link.<br>If you have any concern, please contact us at <span\r\n                    style=\"font-weight:bold;\"><a\r\n                        :href=\"`mailto:${support_email_address}`\">{{ support_email_address }}</a></span>\r\n            </p>\r\n        </div>\r\n    </div>\r\n    <div v-else style=\"width: 100%;\">\r\n        <div class=\"header-container\">\r\n            <img :src=\"logo_file_path\" alt=\"Logo\" style=\"width: 9rem; margin: 1rem;\" />\r\n            <h4>E-Invoice <br class=\"mobile-next\"> Submission Form </h4>\r\n        </div>\r\n        <div class=\"form-container\">\r\n            <div style=\"background-color: #e4e4e4;\" class=\"rounded\" v-if=\"isSubmitted\">\r\n                <div style=\"display: flex; justify-content: center; margin-top: 20px;\">\r\n                    <svg  width=\"40px\" height=\"40px\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n                        <path opacity=\"0.5\" d=\"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z\" fill=\"#008000\"/>\r\n                        <path d=\"M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z\" fill=\"#ffffff\"/>\r\n                    </svg>\r\n                </div>\r\n                <p style=\"text-align: center; font-size: 14px; font-weight: bold; justify-content: center; margin: 8px;\">\r\n                    Congratulations! Your E-Invoice request has been successfully submitted.\r\n                </p>\r\n            </div>\r\n            <p></p>\r\n            <form @submit.prevent=\"submitForm\">\r\n                <div class=\"form-group\">\r\n                    <label for=\"pos_invoice_no\">POS Invoice No <span style=\"color: red;\">*</span></label>\r\n                    <input type=\"text\" v-model=\"formData.pos_invoice_no\" placeholder=\"POS Invoice No\" disabled />\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label class=\"unstyled\" for=\"date\">Transaction Date (YYYY-MM-DD)<span\r\n                            style=\"color: red;\">*</span></label>\r\n                    <input type=\"text\" v-model=\"formData.date\" placeholder=\"Date\" disabled>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"store_name\">Store Name <span style=\"color: red;\">*</span></label>\r\n                    <input type=\"text\" v-model=\"formData.store_name\" placeholder=\"Store Name\" disabled />\r\n                </div>\r\n                <hr width=\"100%\" size=\"4\" noshade>\r\n                <div>\r\n                    <h5 style=\"font-size: medium; font-weight: bold; margin-bottom: 20px;\">PERSONAL DETAILS</h5>\r\n                    <p></p>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"full_name\">Full Name (as per ID) <span style=\"color: red;\">*</span></label>\r\n                    <input type=\"text\" v-model=\"formData.full_name\" placeholder=\"e.g. Syatifah binti Ibrahim\" required\r\n                        :disabled=\"isSubmitted\">\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"email_address\">Email Address <span style=\"color: red;\">*</span></label>\r\n                    <input id=\"email-field\" type=\"text\" v-model=\"formData.email_address\"\r\n                        placeholder=\"e.g. syatifah@gmail.com\" required :disabled=\"isSubmitted\">\r\n                    <div style=\"font-size: 0.875rem;\" class=\"form-error-msg\">\r\n                        <span v-if=\"form_error_data.email\" style=\"color: red;\">{{ form_error_data.email }}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"phone_number\">Phone Number <span style=\"color: red;\">*</span></label>\r\n                    <input id=\"phone\" type=\"tel\" :disabled=\"isSubmitted\" required />\r\n                    <div style=\"font-size: 0.875rem;\" class=\"form-error-msg\">\r\n                        <span v-if=\"form_error_data.phone\" style=\"color: red;\">{{ form_error_data.phone }}</span>\r\n                    </div>\r\n                </div>\r\n                <label for=\"customer_type\">Claim as:</label>\r\n                <div style=\"display: flex; align-items: center; gap: 25px\">\r\n                    <div class=\"form-check\" style=\"display: flex;\">\r\n                        <input class=\"form-check-input\" type=\"radio\" name=\"customer_type\" value=\"Individual\"\r\n                            id=\"individual\" v-model=\"formData.customer_type\" required :disabled=\"isSubmitted\"\r\n                            :checked=\"formData.customer_type === 'Individual'\">\r\n                        <label class=\"form-check-label\" for=\"individual\" style=\"cursor: pointer;\">\r\n                            Individual\r\n                        </label>\r\n                    </div>\r\n                    <div class=\"form-check\" style=\"display: flex;\">\r\n                        <input class=\"form-check-input\" type=\"radio\" name=\"customer_type\" value=\"Company\" id=\"company\"\r\n                            v-model=\"formData.customer_type\" required :disabled=\"isSubmitted\"\r\n                            :checked=\"formData.customer_type === 'Company'\">\r\n                        <label class=\"form-check-label\" for=\"company\" style=\"cursor: pointer;\">\r\n                            Company\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n                <p></p>\r\n                <hr v-if=\"formData.customer_type\" width=\"100%\" size=\"4\" noshade>\r\n                <div v-if=\"formData.customer_type === 'Individual'\">\r\n                    <h5 style=\"font-size: medium; font-weight: bold; margin-bottom: 20px;\">INDIVIDUAL DETAILS</h5>\r\n                    <p></p>\r\n                    <label for=\"individual-type\">Individual ID <span style=\"color: red;\">*</span></label>\r\n                    <div style=\"display: flex; align-items: center; gap: 15px; margin-bottom: 10px;\">\r\n                        <div class=\"form-check\" style=\"display: flex;\">\r\n                            <input class=\"form-check-input\" type=\"radio\" name=\"identification_number_type\" value=\"MyKad\"\r\n                                id=\"NRIC\" v-model=\"formData.identification_number_type\" required :disabled=\"isSubmitted\"\r\n                                :checked=\"formData.identification_number_type === 'MyKad'\">\r\n                            <label class=\"form-check-label\" for=\"NRIC\" style=\"cursor: pointer;\">\r\n                                MyKad\r\n                            </label>\r\n                        </div>\r\n                        <div class=\"form-check\" style=\"display: flex;\">\r\n                            <input class=\"form-check-input\" type=\"radio\" name=\"identification_number_type\" id=\"Passport\"\r\n                                value=\"Passport\" v-model=\"formData.identification_number_type\" required\r\n                                :disabled=\"isSubmitted\" :checked=\"formData.identification_number_type === 'Passport'\">\r\n                            <label class=\"form-check-label\" for=\"Passport\" style=\"cursor: pointer;\">\r\n                                Passport\r\n                            </label>\r\n                        </div>\r\n                        <div class=\"form-check\" style=\"display: flex;\">\r\n                            <input class=\"form-check-input\" type=\"radio\" name=\"identification_number_type\" id=\"Army\"\r\n                                value=\"MyTentera\" v-model=\"formData.identification_number_type\" required\r\n                                :disabled=\"isSubmitted\" :checked=\"formData.identification_number_type === 'MyTentera'\">\r\n                            <label class=\"form-check-label\" for=\"Army\" style=\"cursor: pointer;\">\r\n                                MyTentera\r\n                            </label>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                        <input type=\"text\" @input=\"ignore_dash_character\" v-model=\"formData.identification_number\"\r\n                            :placeholder=\"getPlaceholder(formData.identification_number_type)\"\r\n                            :required=\"formData.identification_number_type\"\r\n                            :disabled=\"isSubmitted || formData.identification_number_type === ''\"\r\n                            id=\"identification_number\">\r\n                        <div style=\"font-size: 0.875rem;\" class=\"form-error-msg\">\r\n                            <span v-if=\"form_error_data.identification_number\" style=\"color: red;\">\r\n                                {{ form_error_data.identification_number }}\r\n                            </span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"form-group\" style=\"margin-bottom: 10px;\">\r\n                        <label for=\"tax_id\">Individual Tax Identification Number (TIN) <span\r\n                                style=\"color: red;\">*</span></label>\r\n                        <input type=\"text\" @input=\"ignore_dash_character\" v-model=\"formData.individual_tin\"\r\n                            placeholder=\"e.g. C1212341234\" :disabled=\"isSubmitted\" id=\"individual_tin\" required>\r\n                        <div style=\"font-size: 0.875rem;\" class=\"form-error-msg\">\r\n                            <span v-if=\"form_error_data.individual_tin\" style=\"color: red;\">{{\r\n                                form_error_data.individual_tin }}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div v-else-if=\"formData.customer_type === 'Company'\">\r\n                    <h5 style=\"font-size: medium; font-weight: bold; margin-bottom: 20px;\">COMPANY DETAILS</h5>\r\n                    <p></p>\r\n                    <div class=\"form-group\" style=\"margin-bottom: 10px;\">\r\n                        <label for=\"company-name\">Company Name <span style=\"color: red;\">*</span></label>\r\n                        <input type=\"text\" v-model=\"formData.company_name\" placeholder=\"e.g. Coffee Shop Sdn. Bhd.\"\r\n                            required :disabled=\"isSubmitted\">\r\n                    </div>\r\n                    <div class=\"form-group\" style=\"margin-bottom: 10px;\">\r\n                        <label for=\"company-id\">Company ID - Business Registration Number (BRN) <span\r\n                                style=\"color: red;\">*</span></label>\r\n                        <input type=\"text\" @input=\"ignore_dash_character\" v-model=\"formData.company_id\"\r\n                            placeholder=\"e.g. 201909123456\" required :disabled=\"isSubmitted\" id=\"company_id\">\r\n                        <div style=\"font-size: 0.875rem;\" class=\"form-error-msg\">\r\n                            <span v-if=\"form_error_data.company_id\" style=\"color: red;\">{{ form_error_data.company_id\r\n                                }}</span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"form-group\" style=\"margin-bottom: 10px;\">\r\n                        <label for=\"tax_id\">Company Tax Identification Number (TIN) <span\r\n                                style=\"color: red;\">*</span></label>\r\n                        <input type=\"text\" @input=\"ignore_dash_character\" v-model=\"formData.company_tin\"\r\n                            placeholder=\"e.g. C1212341234\" :disabled=\"isSubmitted\" id=\"company_tin\" required>\r\n                        <div style=\"font-size: 0.875rem;\" class=\"form-error-msg\">\r\n                            <span v-if=\"form_error_data.company_tin\" style=\"color: red;\">{{ form_error_data.company_tin\r\n                                }}</span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"form-group\" style=\"margin-bottom: 10px;\">\r\n                        <label for=\"sst_registration_no\">SST Registration Number (Mandatory for SST-registrant)</label>\r\n                        <input type=\"text\" @input=\"ignore_dash_character\" v-model=\"formData.sst_number\"\r\n                            placeholder=\"e.g. X89-2104-12345678\" :disabled=\"isSubmitted\" id=\"company_sst_number\">\r\n                        <div style=\"font-size: 0.875rem;\" class=\"form-error-msg\">\r\n                            <span v-if=\"form_error_data.company_sst_number\" style=\"color: red;\">{{\r\n                                form_error_data.company_sst_number }}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"address\">Address Line 1 <span style=\"color: red;\">*</span></label>\r\n                    <input type=\"text\" v-model=\"formData.address_line_1\" placeholder=\"e.g. Unit No, Street Name\"\r\n                        :disabled=\"isSubmitted\" required>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"address\">Address Line 2 </label>\r\n                    <input type=\"text\" v-model=\"formData.address_line_2\" placeholder=\"e.g. Unit No, Street Name\"\r\n                        :disabled=\"isSubmitted\">\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"country\">Country <span style=\"color: red;\" >*</span></label>\r\n                    <select class=\"w-full md:w-56\" v-model=\"formData.country\" :disabled=\"isSubmitted\" placeholder=\"Select a Country\">\r\n                        <option v-for=\"country in countries_list\" :value=\"country.name\">{{ country.name }}</option>\r\n                    </select>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"state\">State <span style=\"color: red;\">*</span></label>\r\n                    <select class=\"w-full md:w-56\" v-model=\"formData.state\" :disabled=\"isSubmitted\" placeholder=\"Select a State\">\r\n                        <option v-for=\"state in filteredStateOptions\" :value=\"state.name\">{{ state.state }}</option>\r\n                    </select>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"city\">City <span style=\"color: red;\">*</span></label>\r\n                    <!--State is not applicable and country is Malaysia-->\r\n                    <select v-if=\"formData.state !== '17' && formData.country === 'Malaysia'\" v-model=\"formData.city\"\r\n                        :class=\"{ 'select_background_white': !isSubmitted, 'select_background_grey': isSubmitted }\"\r\n                        required :disabled=\"isSubmitted\">\r\n                        <option v-for=\"city, index in cities()\" :key=\"index\" :value=\"city\">\r\n                            {{ city }}\r\n                        </option>\r\n                    </select>\r\n                    <input type=\"text\" v-else-if=\"formData.state === '17' && formData.country === 'Malaysia'\"\r\n                        placeholder=\"Please select a state in Malaysia!\" disabled>\r\n                    <input type=\"text\" v-else-if=\"formData.state === '17' && formData.country !== 'Malaysia'\"\r\n                        v-model=\"formData.city\" required :disabled=\"isSubmitted\" placeholder=\"e.g. New York\">\r\n                    <input type=\"text\" v-else-if=\"formData.state\" placeholder=\"Select 'Not Applicable' on 'State'.\"\r\n                        disabled>\r\n                    <input type=\"text\" v-else placeholder=\"Please choose 'State' first.\" disabled>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label for=\"city\">Postal Code <span style=\"color: red;\">*</span></label>\r\n                    <input type=\"text\" id=\"postal_code\" v-model=\"formData.postal_code\" placeholder=\"e.g. 43200\" required\r\n                        :disabled=\"isSubmitted\">\r\n                </div>\r\n                <div class=\"form-group d-flex mt-8\">\r\n                    <input type=\"checkbox\" id=\"agreement\" v-model=\"formData.accept_privacy_policy_and_tac\" required\r\n                        :disabled=\"isSubmitted\">\r\n                    <label for=\"agreement\" class=\"agreement-label\">By ticking this box, you consent to abide by the\r\n                        <a :href=\"`/terms-and-conditions`\" target=\"_blank\"\r\n                            style=\"color: #6b68ff; text-decoration: underline;\">Terms and Conditions</a> as well as <a\r\n                            :href=\"`/privacy-policy`\" target=\"_blank\"\r\n                            style=\"color: #6b68ff; text-decoration: underline;\">Privacy Policy</a>\r\n                        outlined herein. Please review the terms\r\n                        carefully before proceeding. Your acceptance indicates your understanding and agreement to be\r\n                        bound by these terms.</label>\r\n                    <div style=\"font-size: 0.875rem;\" class=\"form-error-msg\">\r\n                        <span v-if=\"form_error_data.agreement\" style=\"color: red;\">{{ form_error_data.agreement\r\n                            }}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-actions\">\r\n                    <button type=\"submit\" class=\"btn-primary\" :class=\"{ 'btn-success': isSubmitted }\"\r\n                        :disabled=\"isSubmitting || isSubmitted\" style=\"border-radius: 2rem; font-weight: bold;\">\r\n                        {{ isSubmitted ? \"Submitted\" : (isSubmitting ? \"Submitting...\" : \"Submit\") }}\r\n                    </button>\r\n                </div>\r\n            </form>\r\n            <div style=\"text-align: center; margin-top: 2rem; color: #398bff; font-size: 14px;\">\r\n                Powered by <a :href=\"`https://www.byondwave.com/`\" target=\"_blank\"\r\n                    style=\"color: #398bff;\">BYONDWAVE.com</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\nimport { getCities } from \"malaysia-postcodes\";\r\nexport default {\r\n    props: [\"customer_session_id\"], \r\n    data() {\r\n        return {\r\n            countries_list: [],\r\n            stateOptions: [],\r\n            logo_file_path: \"\",\r\n            phone_instance: null,\r\n            formData: {\r\n                customer_session_id: this.customer_session_id,\r\n                pos_invoice_no: \"\",\r\n                date: '',\r\n                store_name: '',\r\n                accept_privacy_policy_and_tac: false,\r\n\r\n                //Personal details\r\n                full_name: '',\r\n                email_address: '',\r\n                phone_number: '',\r\n                customer_type: 'Individual',\r\n\r\n                //Individual details\r\n                identification_number_type: '',\r\n                identification_number: '',\r\n                individual_tin: '',\r\n\r\n                //Company details\r\n                company_name: '',\r\n                company_id: '',\r\n                company_tin: '',\r\n                sst_number: '',\r\n\r\n                //Address details\r\n                address_line_1: '',\r\n                address_line_2: '',\r\n                country: '',\r\n                state: '',\r\n                city: '',\r\n                postal_code: '',\r\n            },\r\n            form_error_data: {},\r\n            isSubmitting: false, // Tracks if the form is being submitted\r\n            isSubmitted: false,\r\n            error: false,\r\n            support_email_address: \"\",\r\n        };\r\n    },\r\n    computed: {\r\n        filteredStateOptions() {\r\n            // Filter out \"All State\"\r\n            return this.stateOptions.filter(option =>\r\n                // option.state !== 'All States'\r\n                option.name !== \"00\"\r\n            )\r\n        },\r\n    },\r\n    watch: {\r\n        \"formData.customer_type\": function (newVal) {\r\n            this.form_error_data = {};\r\n            // Clear irrelevant fields based on the selected customer type\r\n            if (newVal === \"Individual\") {\r\n                this.formData.company_name = \"\";\r\n                this.formData.company_id = \"\";\r\n                this.formData.company_tin = \"\";\r\n                this.formData.sst_number = \"\";\r\n            } else if (newVal === \"Company\") {\r\n                this.formData.individual_address = \"\";\r\n                this.formData.identification_number_type = \"\";\r\n                this.formData.identification_number = \"\";\r\n                this.formData.individual_tin = \"\";\r\n            }\r\n        },\r\n    },\r\n    methods: {\r\n        getPlaceholder(type) {\r\n            switch (type) {\r\n                case 'MyKad': return 'e.g. 971213081234';\r\n                case 'Passport': return 'e.g. A12345678';\r\n                case 'MyTentera': return 'e.g. 971213081234';\r\n                default: return 'Please select identification number type!';\r\n            }\r\n        },\r\n        cities() {\r\n            //Convert state code (.name) to state name (.state)\r\n            state_name = \"\";\r\n            const selectedState = this.stateOptions.find(\r\n                state_code => state_code.name === this.formData.state\r\n            );\r\n            if (selectedState) {\r\n                state_name = selectedState.state;\r\n            }\r\n            // Return cities dictionary for primevue Select component\r\n            if (state_name === 'Wilayah Persekutuan Kuala Lumpur') //The library only recognise \"Wp Kuala Lumpur\", \"Wp Labuan\" and \"Wp Putrajaya\"\r\n                return [{'name': 'Kuala Lumpur'}]\r\n            else if (state_name === 'Wilayah Persekutuan Labuan')\r\n                return [{'name': \"Labuan\"}]\r\n            else if (state_name === 'Wilayah Persekutuan Putrajaya')\r\n                return [{'name': \"Putrajaya\"}]\r\n            else if (state_name === 'Pulau Pinang')\r\n                state_name = \"Penang\"\r\n            return getCities(state_name).map(city => {return {'name': city};});\r\n        },\r\n        get_pos_invoice_no() {\r\n            frappe.call({\r\n                method: \"myinvois.api.get_pos_invoice_no\",\r\n                args: {\r\n                    customer_session_id: this.customer_session_id,\r\n                },\r\n                callback: (response) => {\r\n                    if (response.success) {\r\n                        this.formData.pos_invoice_no = response.message.pos_invoice_no;\r\n                        this.formData.store_name = response.message.store_name;\r\n                        this.formData.date = response.message.transaction_date;\r\n                        this.logo_file_path = response.message.logo_file_path;\r\n                    } else {\r\n                        this.error = true;\r\n                        this.support_email_address = response.message.support_email_address;\r\n                    }\r\n                }\r\n            });\r\n        },\r\n        validate_form() {\r\n            let isValid = true;\r\n            this.form_error_data = {}; // Clear previous errors\r\n            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$/;\r\n            const passportPattern = /^[AHKahk]\\d{8}$/;\r\n            const individualTINPattern = /^(IG)(\\d{9,11})$/;\r\n            const nonIndividualTINPattern = /^[CDEF](\\d{9,11})0$/;\r\n            const nricPattern = /^\\d{6}\\d{2}\\d{4}$/;\r\n            const brnPattern = /^\\d{4}(01|02|03|04|05|06)\\d{6}$/;\r\n            const sstRegNoPattern = /^[A-Z]\\d{2}\\d{4}\\d{8}$/;\r\n            const email_input = document.querySelector(\"#email-field\");\r\n            const phone_input = document.querySelector(\"#phone\");\r\n            const identification_number_input = document.querySelector(\"#identification_number\");\r\n            const individual_tin_input = document.querySelector(\"#individual_tin\");\r\n            const company_tin_input = document.querySelector(\"#company_tin\");\r\n            const company_id_input = document.querySelector(\"#company_id\");\r\n            const company_sst_number_input = document.querySelector(\"#company_sst_number\");\r\n\r\n            const patterns = {\r\n                'MyKad': nricPattern,\r\n                'MyTentera': nricPattern,\r\n                'Passport': passportPattern,\r\n            };\r\n\r\n            if (this.formData.customer_type === \"Individual\") {\r\n                // Identification Number Type\r\n                if (this.formData.identification_number_type) {\r\n                    // Identification Number\r\n                    if (identification_number_input) {\r\n                        const value = this.formData.identification_number;\r\n                        const pattern = patterns[this.formData.identification_number_type];\r\n                        const errorMessage = `Please enter a valid ${this.formData.identification_number_type} number.`;\r\n                        if (!value || value === null || !pattern.test(value)) {\r\n                            this.form_error_data.identification_number = errorMessage;\r\n                            isValid = false;\r\n                            identification_number_input.style.borderColor = \"red\";\r\n                        } else {\r\n                            identification_number_input.style.borderColor = \"\";\r\n                        }\r\n                    } else {\r\n                        console.error(`${this.formData.identification_number_type.toUpperCase()} input element not found.`);\r\n                    }\r\n                } else {\r\n                    console.error(\"Identification number type is not specified.\");\r\n                }\r\n\r\n                // Individual TIN\r\n                if (!this.formData.individual_tin || this.formData.individual_tin === null || !individualTINPattern.test(this.formData.individual_tin)) {\r\n                    this.form_error_data.individual_tin = \"Please enter a valid TIN.\";\r\n                    isValid = false;\r\n                    individual_tin_input.style.borderColor = \"red\";\r\n                } else {\r\n                    individual_tin_input.style.borderColor = \"\";\r\n                }\r\n            }\r\n\r\n            // Company \r\n            if (this.formData.customer_type === \"Company\") {\r\n                // Company TIN\r\n                if (!this.formData.company_tin || this.formData.company_tin === null || !nonIndividualTINPattern.test(this.formData.company_tin)) {\r\n                    this.form_error_data.company_tin = \"Please enter a valid TIN.\";\r\n                    isValid = false;\r\n                    company_tin_input.style.borderColor = \"red\";\r\n                } else {\r\n                    company_tin_input.style.borderColor = \"\";\r\n                }\r\n                // Company BRN / Company ID\r\n                if (!this.formData.company_id || this.formData.company_id === null || !brnPattern.test(this.formData.company_id)) {\r\n                    this.form_error_data.company_id = \"Please enter a valid BRN.\";\r\n                    isValid = false;\r\n                    company_id_input.style.borderColor = \"red\";\r\n                } else {\r\n                    company_id_input.style.borderColor = \"\";\r\n                }\r\n                // Company SST Registration No\r\n                if (this.formData.sst_number !== \"\" && !sstRegNoPattern.test(this.formData.sst_number)) {\r\n                    this.form_error_data.company_sst_number = \"Please enter a valid SST Registration No.\";\r\n                    isValid = false;\r\n                    company_sst_number_input.style.borderColor = \"red\";\r\n                } else {\r\n                    company_sst_number_input.style.borderColor = \"\";\r\n                }\r\n            }\r\n\r\n            // Email Address\r\n            if (!this.formData.email_address || !emailPattern.test(this.formData.email_address)) {\r\n                this.form_error_data.email = \"Please enter a valid email address.\";\r\n                isValid = false;\r\n                email_input.style.borderColor = \"red\";\r\n            } else {\r\n                email_input.style.borderColor = \"\";\r\n            }\r\n            // Phone Number\r\n            if (!this.phone_instance) {\r\n                if (!phone_input.value) {\r\n                    this.form_error_data.phone = \"Please enter a phone number.\";\r\n                    isValid = false;\r\n                    phone_input.style.borderColor = \"red\";\r\n                } else {\r\n                    phone_input.style.borderColor = \"\";\r\n                }\r\n            } else {\r\n                const isValidPhone = this.phone_instance.isValidNumber();\r\n                if (!isValidPhone) {\r\n                    this.form_error_data.phone = \"Please enter a valid phone number.\";\r\n                    isValid = false;\r\n                    phone_input.style.borderColor = \"red\";\r\n                } else {\r\n                    phone_input.style.borderColor = \"\";\r\n                }\r\n            }\r\n            return isValid;\r\n        },\r\n        submitForm() { //Fill in the E-Invoice Request record.\r\n            if (this.isSubmitting || this.isSubmitted) return;\r\n            const isValid = this.validate_form();\r\n            if (!isValid) return;\r\n            this.update_phone_number();\r\n            this.isSubmitting = true;\r\n            frappe.call({\r\n                method: \"myinvois.api.create_einvoice_request_record\",\r\n                args: { formData: this.formData },\r\n                callback: (response) => {\r\n                    if (response.success) {\r\n                        this.isSubmitted = true;\r\n                        frappe.show_alert({\r\n                            title: \"Success\",\r\n                            indicator: \"green\",\r\n                            message: \"Data submitted successfully.\",\r\n                        });\r\n                    }\r\n                    else {\r\n                        frappe.msgprint({\r\n                            title: \"Invalid\",\r\n                            indicator: \"red\",\r\n                            message: response.message,\r\n                        });\r\n                    }\r\n                },\r\n                error: () => {\r\n                    this.isSubmitting = false;\r\n                }\r\n            });\r\n        },\r\n        fetchValues() { // Map back the E-Invoice Request Record if it is submitted.\r\n            frappe.call({\r\n                method: \"myinvois.api.fetch_einvoice_request_record\",\r\n                args: {\r\n                    customer_session_id: this.customer_session_id\r\n                },\r\n                callback: (response) => {\r\n                    if (response.success) {\r\n                        einvoice_request_doc = response['einvoice_request_doc'];\r\n                        if (einvoice_request_doc.docstatus == 1) {\r\n                            this.isSubmitted = true; //disabled the form inputs\r\n                            //Personal details\r\n                            this.formData.full_name = einvoice_request_doc.full_name;\r\n                            this.formData.email_address = einvoice_request_doc.email_address;\r\n                            this.formData.customer_type = einvoice_request_doc.customer_type;\r\n                            this.formData.address_line_1 = einvoice_request_doc.address_line_1;\r\n                            this.formData.address_line_2 = einvoice_request_doc.address_line_2;\r\n                            this.formData.state = einvoice_request_doc.state;\r\n                            this.formData.city = einvoice_request_doc.city;\r\n                            this.formData.country = einvoice_request_doc.country;\r\n                            this.formData.postal_code = einvoice_request_doc.postal_code;\r\n                            this.formData.accept_privacy_policy_and_tac = Boolean(einvoice_request_doc.accept_privacy_policy_and_tac);\r\n                            // Update intl-tel-input instance with the fetched phone number\r\n                            if (this.phone_instance) {\r\n                                this.phone_instance.setNumber(einvoice_request_doc.mobile_number);\r\n                            }\r\n                            //Individual details\r\n                            if (einvoice_request_doc.customer_type == \"Individual\") {\r\n                                this.formData.identification_number_type = einvoice_request_doc.identification_number_type;\r\n                                this.formData.identification_number = einvoice_request_doc.identification_number;\r\n                                this.formData.individual_tin = einvoice_request_doc.individual_tin;\r\n                            }\r\n                            //Company details\r\n                            else if (einvoice_request_doc.customer_type == \"Company\") {\r\n                                this.formData.company_name = einvoice_request_doc.company_name;\r\n                                this.formData.company_id = einvoice_request_doc.company_id;\r\n                                this.formData.company_tin = einvoice_request_doc.company_tin;\r\n                                this.formData.sst_number = einvoice_request_doc.sst_registration_no;\r\n                            }\r\n\r\n                        }\r\n                    }\r\n                },\r\n\r\n            })\r\n        },\r\n        initPhoneInput() {\r\n            const phone_input = document.querySelector(\"#phone\");\r\n            if (!phone_input) {\r\n                console.error(\"Phone input element not found!\");\r\n                return;\r\n            }\r\n            this.phone_instance = intlTelInput(phone_input, {\r\n                initialCountry: \"my\",\r\n                loadUtils: () => import(\"https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js\"),\r\n                separateDialCode: true,\r\n                useFullscreenPopup: false,\r\n                autoPlaceholder: \"aggressive\"\r\n            });\r\n            phone_input.addEventListener(\"input\", this.update_phone_number);\r\n            phone_input.addEventListener(\"countrychange\", this.update_phone_number);\r\n        },\r\n        update_phone_number() {\r\n            if (this.phone_instance) {\r\n                const formatted_number = this.phone_instance.getNumber();\r\n                const is_valid = this.phone_instance.isValidNumber();\r\n                if (is_valid !== false) {\r\n                    this.formData.phone_number = formatted_number;\r\n                }\r\n            }\r\n        },\r\n        ignore_dash_character(event) {\r\n            const inputElement = event.target;\r\n            inputElement.value = inputElement.value.replace(/-/g, ''); // Remove \"-\" from input while typing in.\r\n        },\r\n        get_country_and_state_codes() {\r\n            frappe.call({\r\n                method: \"myinvois.api.get_country_and_state_codes\",\r\n                args: {},\r\n                callback: (response) => {\r\n                    if (response.message) {\r\n                        this.stateOptions = response.message.state_codes;\r\n                        this.countries_list = response.message.countries;\r\n                    }\r\n                }\r\n            });\r\n        },\r\n    },\r\n    mounted() {\r\n        this.get_pos_invoice_no();\r\n        this.get_country_and_state_codes();\r\n        this.fetchValues();\r\n        this.$nextTick(() => {\r\n            this.initPhoneInput();\r\n        });\r\n    },\r\n    beforeUnmount() {\r\n        // Clean up the intl-tel-input instance\r\n        if (this.phone_instance) {\r\n            this.phone_instance.destroy();\r\n        }\r\n    },\r\n};\r\n</script>\r\n\r\n<style scoped>\r\n.header-container {\r\n    text-align: center;\r\n    background-color: #3663e6;\r\n    padding: 20px;\r\n    max-width: 600px;\r\n    margin: 3rem auto 0 auto;\r\n    border-top-left-radius: 1rem;\r\n    border-top-right-radius: 1rem;\r\n}\r\n\r\nh4 {\r\n    color: white;\r\n    margin-top: 1.2rem;\r\n    margin-bottom: 0.5rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.form-container {\r\n    background: white;\r\n    padding: 20px 50px;\r\n    max-width: 600px;\r\n    margin: 0rem auto 3rem auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    border-bottom-left-radius: 1rem;\r\n    border-bottom-right-radius: 1rem;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\nlabel {\r\n    font-weight: 600;\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    color: #555;\r\n}\r\n\r\ninput {\r\n    border-radius: 10px !important;\r\n}\r\n\r\ninput:not([type=\"radio\"]),\r\nselect {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 10px;\r\n    font-size: 14px;\r\n    transition: border-color 0.2s ease;\r\n}\r\n\r\ninput:focus,\r\nselect:focus {\r\n    border-color: #007bff;\r\n    outline: none;\r\n}\r\n\r\n.form-actions {\r\n    text-align: center;\r\n}\r\n\r\n.btn-primary {\r\n    background-color: #007bff;\r\n    border: none;\r\n    color: white;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.btn-primary:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n.example-text {\r\n    color: #93999c;\r\n    margin-bottom: 5px;\r\n    font-size: 14px;\r\n}\r\n\r\n.mobile-next {\r\n    display: none;\r\n}\r\n\r\n.error-box {\r\n    background-color: #f8d7da;\r\n    color: #721c24;\r\n    border: 1px solid #f5c6cb;\r\n    border-radius: 5px;\r\n    margin: 0 2rem;\r\n    padding: 20px;\r\n    font-size: 16px;\r\n    text-align: center;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.btn-success {\r\n    background-color: #28a745;\r\n    color: white;\r\n    border-color: #28a745;\r\n}\r\n\r\n.select_background_white {\r\n    background-color: white;\r\n    color: black;\r\n}\r\n\r\n.select_background_grey {\r\n    background-color: #f8f8f8;\r\n    color: black;\r\n}\r\n\r\n.unstyled {\r\n    appearance: none;\r\n    -webkit-appearance: none;\r\n}\r\n\r\n.unstyled::-webkit-inner-spin-button,\r\n.unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n\r\nlabel {\r\n    font-size: 1rem;\r\n}\r\n\r\n#agreement {\r\n    border-radius: 6px !important;\r\n    margin: 5px 11px 0 0 !important;\r\n    padding: 8px;\r\n}\r\n\r\n.agreement-label {\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    text-align: justify;\r\n}\r\n\r\n@media (max-width: 575.99px) {\r\n    .header-container {\r\n        margin: 1rem 2rem 0 2rem;\r\n    }\r\n\r\n    .form-container {\r\n        margin: 0rem 2rem 1rem 2rem;\r\n        padding: 20px;\r\n    }\r\n\r\n    .mobile-next {\r\n        display: block;\r\n    }\r\n\r\n    h4 {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    label {\r\n        font-size: 0.875rem;\r\n    }\r\n\r\n    .agreement-label {\r\n        font-size: 12px;\r\n    }\r\n}\r\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-dd8c2920"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../myinvois/myinvois/public/js/einvoice_request/Home.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__